export default __webpack_public_path__ + "static/media/FacingImg.15c248af.jpg";